
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import UserService from '@/services/user.service';
import { BASE_URL } from '@/common/constant';
import ImageViewer from '@/components/ImageViewer.vue';

@Component({
  components: {
    ImageViewer,
  },
})
export default class InvoiceUploadModal extends Vue {
  @Ref('imageViewer')
  imageViewer!: any;
  visible = false;

  uploading = false;

  record: any = {};

  fileList: any[] = [];

  BASE_URL = BASE_URL;

  token: any = '';

  type = '';

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @lazyInject(UserService)
  userService!: UserService;

  open(record: any, type: string) {
    this.record = record || {};
    this.type = type;
    this.visible = true;
    this.fileList = [];
  }

  mounted() {
    this.token = this.userService.currentUser()?.token;
  }

  async onChange(info: any) {
    if (info.file.status === 'uploading') {
      this.uploading = true;
      return;
    }
    if (info.file.status === 'done') {
      const res = JSON.parse(info.file.xhr.response);
      this.uploading = false;
      const fileData = res.data?.[0];
      if (fileData) {
        this.fileList.push({
          uid: info.file.uid,
          name: info.file.name,
          status: 'done',
          url: fileData.url,
          id: fileData.id,
        });
      }
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} 上传失败`);
    }
  }

  handleRemove(file: any) {
    const index = this.fileList.findIndex((item) => item.uid === file.uid);
    if (index > -1) {
      this.fileList.splice(index, 1);
    }
  }

  previewImage(url: string) {
    this.imageViewer.open([url]);
  }

  async submitInvoice() {
    if (this.fileList.length === 0) {
      this.$message.error('请至少上传一张发票');
      return;
    }
    const licenseIds = this.fileList.map((item) => item.id).filter(Boolean);
    if (licenseIds.length === 0) {
      this.$message.error('发票上传失败，请重试');
      return;
    }
    try {
      const res = await this.supplyService.postUploadPlatInvoice({
        batch_no: this.record.batchNo,
        resource_no: licenseIds,
        category: this.type,
      });
      if (res) {
        this.$message.success(res);
        this.onClose();
        this.$emit('refresh');
      }
    } catch (e) {
      console.error(e);
    }
  }

  onClose() {
    this.visible = false;
    this.record = {};
    this.fileList = [];
  }

  beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error('请上传 png/jpeg 格式的照片!');
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('照片必须小于5MB!');
    }

    return isJpgOrPng && isLt5M;
  }
}
